import { createCreateActionType, createCreateFetchingKey } from "@multiweb/reactUtils";

/**
 * Jméno modulu aggregationRow. Slouží pro jednoznačnou identifikaci modulu.
 */
export const NAME = "aggregationRow";

/**
 * Klíč pro identifikaci načítání statických lokalizací.
 */
export const FETCHING_KEY_STATIC_ITEMS = createCreateFetchingKey(NAME)("staticItems");

/**
 * Výchozí formát pro čísla. Převzaté z NumberUtils.ts protože je součástí implementace bez strict módu.
 * general - oddělovač tisíců a variabilní desetinná místa.
 */
export const DEFAULT_FORMAT_GENERAL = "g";

/**
 * Pomocná funkce pro vytvoření typu akce
 * @param actionType Typ akce
 */
const createActionType = createCreateActionType(NAME);

export const INIT_AGGREGATION_ROW = createActionType("INIT_AGGREGATION_ROW");
export const CLEAR_AGGREGATION_ROW = createActionType("CLEAR_AGGREGATION_ROW");
export const AGGREGATION_FUNCTION_SELECTED = createActionType("AGGREGATION_FUNCTION_SELECTED");
export const SET_AGGREGATION_RESULTS = createActionType("SET_AGGREGATION_RESULTS");
export const COLUMN_WIDTH_CHANGED = createActionType("COLUMN_WIDTH_CHANGED");
export const NUMBER_OF_FROZEN_COLUMNS_CHANGED = createActionType("NUMBER_OF_FROZEN_COLUMNS_CHANGED");
export const ORDER_OF_COLUMNS_CHANGED = createActionType("ORDER_OF_COLUMNS_CHANGED");
export const COLUMN_DEFINITIONS_CHANGED = createActionType("COLUMN_DEFINITIONS_CHANGED");
export const COLUMN_ADDED = createActionType("COLUMN_ADDED");
export const COLUMN_REMOVED = createActionType("COLUMN_REMOVED");
export const RELOAD_AGGREGATION_RESULTS = createActionType("RELOAD_AGGREGATION_RESULTS");
export const CLOSE_BUTTON_ACTIVATED = createActionType("CLOSE_BUTTON_ACTIVATED");
export const FILTER_CHANGED = createActionType("FILTER_CHANGED");
